import Vue from 'vue'

class AnomalyRepository {
  subscription(organizationId, expensePeriodId) {
    return new Promise((resolve, reject) => {
      const params = []
      if (organizationId) params.push('organizationId=' + organizationId)
      if (expensePeriodId) params.push('expensePeriodId=' + expensePeriodId)
      let url = '/api/anomaly/subscription'
      if (params.length) url += '?' + params.join('&')
      Vue.auth.fetch({
        url,
        method: 'post',
      }).then(
          response => resolve(response.data)
      ).catch(
          err => reject(err)
      )
    })
  }

}

export default new AnomalyRepository()
